'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
exports.default = accessors;
var _ramda = require('ramda');
var _constants = require('../utils/constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function accessors(target) {
  target.accessors = (0, _extends3.default)({}, target.accessors, {
    format: function format(options) {
      return (0, _ramda.path)(['legend', 'choropleth', 'axis', 'format'], options);
    },
    height: function height(options) {
      return (0, _ramda.pathOr)(null, ['legend', 'choropleth', 'height'], options);
    },
    orient: function orient(options) {
      return (0, _ramda.pathOr)(_constants.BOTTOM, ['legend', 'choropleth', 'axis', 'orient'], options);
    },
    margin: function margin(options) {
      return (0, _ramda.path)(['legend', 'choropleth', 'margin'], options);
    },
    tickSize: function tickSize(options) {
      return (0, _ramda.path)(['legend', 'choropleth', 'axis', 'tick', 'size'], options);
    },
    width: function width(options) {
      return (0, _ramda.pathOr)(null, ['legend', 'choropleth', 'width'], options);
    }
  });
}